module.exports = "../fonts/ApercuLAPhil-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./@fonts/apercu-laphil/ApercuLAPhil-Medium.woff2
// module id = 507
// module chunks = 7